import styles from './OnboardingProgress.module.css';

interface Step {
  label: string;
  description: string;
}

interface OnboardingProgressProps {
  steps: Step[];
  currentStep: number;
}

export function OnboardingProgress({ steps, currentStep }: OnboardingProgressProps) {
  return (
    <div className={styles.progress}>
      {steps.map((step, index) => {
        const isComplete = index < currentStep;
        const isCurrent = index === currentStep;
        return (
          <div key={step.label} className={styles.stepWrapper}>
            <div className={`${styles.step} ${isComplete ? styles.complete : ''} ${isCurrent ? styles.current : ''}`}>
              <div className={styles.indicator}>
                {isComplete ? (
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M3 8L6.5 11.5L13 5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                ) : (
                  <span>{index + 1}</span>
                )}
              </div>
              <div className={styles.info}>
                <span className={styles.label}>{step.label}</span>
                <span className={styles.description}>{step.description}</span>
              </div>
            </div>
            {index < steps.length - 1 && <div className={`${styles.connector} ${isComplete ? styles.connectorComplete : ''}`} />}
          </div>
        );
      })}
    </div>
  );
}
